import { Session } from '@ais-ui/auth';

export const reconfigureReport = async (
  session: Session,
  jobUuid: string,
  params: Record<string, unknown>,
) => {
  const response = await session.request('reconfigureJob', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    jobUuid: jobUuid,
    params: JSON.stringify(params),
  });

  return response;
};
